import { FormField, QueryItem } from "../types/Query";
import FormFieldRenderer, { FormRenderConfig } from "./FromFieldRenderer";

interface Props {
  fields: FormField[];
  formData: QueryItem;
  onChange: (e: any) => void;
  setFormData: React.Dispatch<React.SetStateAction<QueryItem>>;
  config?: FormRenderConfig;
}

export default function QueryForm({
  fields,
  formData,
  onChange,
  setFormData,
  config,
}: Props) {
  return (
    <>
      {fields
        .filter((field) => field.isSelected)
        .map((field) => (
          <FormFieldRenderer
            key={field.id}
            field={field}
            formData={formData}
            onChange={onChange}
            setFormData={setFormData}
            config={config}
          />
        ))}
    </>
  );
}
